import React, { FC, useCallback, useEffect } from 'react';
import styles from '../index.module.scss';
import { Button, Form, Input } from 'src/common';
import { useLoadInboxes, useUpdateInboxName } from 'src/models/callOffs/hooks';
import { IInbox } from 'src/models/callOffs/types';
import { useTranslation } from 'react-i18next';

interface IFormState {
  title: string;
}

interface IProps {
  currentInbox: IInbox;
  accessToEdit: boolean;
}

export const RenameInboxForm: FC<IProps> = props => {
  const { currentInbox, accessToEdit } = props;
  const { t } = useTranslation();

  const [form] = Form.useForm();
  const [renameInbox] = useUpdateInboxName();

  const { data: inboxes } = useLoadInboxes();
  const onRenameInbox = useCallback(
    (values: IFormState) => {
      const { title: updatedInboxName } = values;
      const sameName =
        inboxes && inboxes.some(inbox => inbox.inboxName.toLowerCase() === updatedInboxName.toLowerCase());

      if (!updatedInboxName) {
        form.setFields([
          {
            name: 'title',
            errors: [t('CallOffs.inboxNameRequired')]
          }
        ]);
      } else if (sameName) {
        form.setFields([
          {
            name: 'title',
            errors: [t('CallOffs.existingInboxNameError')]
          }
        ]);
      } else {
        renameInbox({
          variables: { inboxName: updatedInboxName, inboxId: currentInbox.emailAddress }
        }).catch(() => {
          form.setFields([
            {
              name: 'title',
              errors: [t('Common.unknownErrorDesc')]
            }
          ]);
        });
      }
    },
    [inboxes, form, t, currentInbox, renameInbox]
  );

  const onValuesChange = useCallback(() => {
    form.setFields([
      {
        name: 'title',
        errors: []
      }
    ]);
  }, [form]);

  useEffect(() => {
    form.resetFields();
  }, [form]);

  return (
    <Form
      initialValues={{ title: currentInbox.inboxName }}
      form={form}
      onFinish={onRenameInbox}
      onValuesChange={onValuesChange}
    >
      <div className={styles.unit}>
        {accessToEdit && (
          <>
            <Form.Item label={t('Common.title')} name="title">
              <Input name="title" type="text" maxLength={30} placeholder={t('Common.name')} />
            </Form.Item>
            <Button type={'default'} htmlType={'submit'}>
              {t('Common.save')}
            </Button>
          </>
        )}
      </div>
    </Form>
  );
};

export default RenameInboxForm;
